// extracted by mini-css-extract-plugin
export default {"subtitle":"ProcessSubtitle_subtitle__72teM","frame":"ProcessSubtitle_frame__7v++V"};